import React from "react";
import { Stack, Text } from "@bookingcom/bui-react";
import useUserAgent from "../../../hooks/useUserAgent";
import { mcn } from "../../../utils/mergeClassnames";
import { type UnifiedPriceTagProps } from "./UnifiedPriceTag";
import { useUnifiedPriceTagController } from "./useUnifiedPriceTag.controller";
import styles from "./UnifiedPriceTag.module.css";

export const UnifiedPriceTagPricePerAdultExplanation = (props: UnifiedPriceTagProps) => {
  const { isMobile } = useUserAgent();
  const { formattedStrikethroughPrice, pricePerAdultExplanation, pricePerAdultExplanationStrikethroughInline } =
    useUnifiedPriceTagController(props);
  const { pricePerAdultExplanationProps, shouldShowPricePerAdult } = props;

  if (!shouldShowPricePerAdult || !pricePerAdultExplanation) return;

  return (
    <Stack
      attributes={pricePerAdultExplanationProps?.attributes}
      className={pricePerAdultExplanationStrikethroughInline ? styles.inline : ""}
    >
      {formattedStrikethroughPrice && (
        <>
          <Text
            color="destructive"
            decoration="line-through"
            variant={
              isMobile && pricePerAdultExplanationProps?.variant ? pricePerAdultExplanationProps.variant : "small_1"
            }
            className={mcn(
              styles.strikedthroughPrice,
              pricePerAdultExplanationStrikethroughInline ? styles.inline : ""
            )}
          >
            {formattedStrikethroughPrice}
          </Text>
          <Text className={pricePerAdultExplanationStrikethroughInline ? styles.inline : ""}> </Text>
        </>
      )}
      <Text
        color="neutral_alt"
        variant={pricePerAdultExplanationProps?.variant || "body_2"}
        className={mcn(
          pricePerAdultExplanationProps?.className,
          pricePerAdultExplanationStrikethroughInline ? styles.inline : ""
        )}
        attributes={{ "data-testid": "upt_price_per_adult_explanation" }}
      >
        {pricePerAdultExplanation}
      </Text>
    </Stack>
  );
};
